import { BaseChartComponent, get, l10nNumber } from './charts-shared';

export default class BarBreakdownChartComponent extends BaseChartComponent {
  constructor(selector, data) {
    super(selector, data);
    this.mapData = (rawData) => {
      const seriesData = get(rawData, 'series');

      const parsedSeries = seriesData.map((s) => {
        s.data = s.data.map((d) => {
          const number = parseFloat(parseFloat(d).toFixed(1));

          return number || 0;
        });

        return s;
      });

      return { parsedSeries, rawData };
    };
  }

  makeChart() {
    const { rawData } = this.data;
    const series = this.data.parsedSeries;
    const stocks = rawData.categories.data;
    const { dataType, displayType } = rawData;
    const isPercentage = dataType === 'percentage';

    Highcharts.chart(this.element.attr('id'), {
      chart: {
        type: displayType === 'bar-chart-horizontal' ? 'bar' : 'column',
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: stocks,
      },
      yAxis: {
        visible: false,
      },

      title: {
        text: null,
      },
      legend: {
        enabled: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },

        series: {
          dataLabels: {
            enabled: true,
            allowOverlap: true,
            color: 'black',
            style: {
              textOutline: 'white',
            },
            formatter() {
              return `${l10nNumber(this.y, isPercentage)}`;
            },
          },
        },
      },
      tooltip: {
        pointFormatter() {
          return `<b>${this.series.name} ${l10nNumber(this.y, isPercentage)}</b>`;
        },
      },
      series,
    });
  }
}
